import { render } from "./aLableStatus.vue?vue&type=template&id=b2cc0f52"
import script from "./aLableStatus.vue?vue&type=script&lang=js"
export * from "./aLableStatus.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__